<template>
  <div>
    <MainNavBar />
    <Hero :hero="heroAconexCde" />
    <Section :content="accessLatest" />
    <Section :content="WipAccessControl" />
    <Section :content="connectSilos" />
    <call-to-action-aconex-register />
    <GmxFooter />
  </div>
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import Section from '@/components/section.vue';
import CallToAction from '@/components/call-to-action.vue';
import GmxFooter from '@/components/footer.vue';
import CallToActionAconexRegister from '../components/call-to-action-aconex-register.vue';
export default {
  name: 'AconexCde',
  components: {
    MainNavBar,
    Hero,
    Section,
    CallToAction,
    GmxFooter,
    CallToActionAconexRegister
  },
  data() {
    return { 
      heroAconexCde: { 
        eyebrowIcon: '',
        eyebrowTitle: '',
        eyebrowSubtitle: '',
        header: 'Oracle Aconex Accelerator CDE',
        subheader: 'The Accelerator offers a single environment to search and access both the Aconex CDE (Common Data Environment) and your Work In Progress with easy hierarchical control, eliminating rework and the need to copy files from the Aconex CDE.',
        img: '',
        videoId: '961761656',
        buttons: [
          /*{ label: 'Text Search', path: '', id: '' },
          { label: 'Tag Search', path: '', id: '' },
          { label: 'Tag Links', path: '', id: '' },*/
          { label: 'Access Latest', path: '', id: 'access-latest-docs' },
          { label: 'WIP Control', path: '', id: 'wip-access-control' },
          { label: 'Connect Silos', path: '', id: 'connect-silos' },
        ]
      },
      accessLatest: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Access to the Latest Documents without Copying',
        paragraphs: [
          'Eliminate massive waste caused by work done from outdated versions due to the need to copy documents from Aconex to your Work In Progress.',
          'With the Accelerator, each project member company has quick access to all of the latest versions of documents in Aconex and to their work in progress from a single application.',
        ],
        id: 'access-latest-docs',
        image: 'placeholder.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      WipAccessControl: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Easy Hierarchical Permission System',
        paragraphs: [
          'Each stakeholder organization has full control over their Work in Progress Project TrinPod\u2122.',
          'Easily add employees and groups to your Organization TrinPod\u2122 or Project TrinPod\u2122 to make collaboration easy and secure with the Accelerator\'s powerful hierarchical permission system.',
        ],
        id: 'wip-access-control',
        image: 'placeholder.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
      },
      connectSilos: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Connect your Silos!',
        paragraphs: [
          'The Accelerator provides one unified environment to access your Aconex Accelerator CDE and your WIP (Work in Progress).',
          'Use one query to search across both your CDE and your WIP with results displayed in a combined list. Open documents stored across your CDE and your WIP in your unified environment.',
        ],
        id: 'connect-silos',
        image: 'placeholder.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      aconexRegisterCTA: {
        header: 'Try It Now',
        bgClass: 'bg-neon-blue-grad',
        btnText: "Get started - it's free",
        btnVariant: 'turquoise'
      }
    }
  }
};
</script>
